import { cn } from '@/utils/cn';

import { StatCardSkeleton } from '@/components/ui/StatCard';



export function Skeleton({ className }: { className?: string }) {

  return (

    <div

      className={cn('animate-pulse rounded-md bg-slate-200/80 dark:bg-slate-800', className)}

      aria-hidden

    />

  );

}



export function TableSkeleton({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {

  return (

    <div className="space-y-2" aria-busy="true" aria-label="Loading table">

      {Array.from({ length: rows }).map((_, row) => (

        <div key={row} className="flex gap-3">

          {Array.from({ length: cols }).map((_, col) => (

            <Skeleton key={col} className="h-9 flex-1" />

          ))}

        </div>

      ))}

    </div>

  );

}



export function PageSkeleton() {

  return (

    <div className="page-content" aria-busy="true" aria-label="Loading page">

      <Skeleton className="h-7 w-48" />

      <Skeleton className="h-4 w-72 max-w-full" />

      <div className="card p-6">

        <TableSkeleton />

      </div>

    </div>

  );

}



export function DashboardSkeleton({ kpiCount = 4 }: { kpiCount?: number }) {

  return (

    <div className="page-content" aria-busy="true" aria-label="Loading dashboard">

      <Skeleton className="h-7 w-56" />

      <Skeleton className="h-4 w-80 max-w-full" />

      <div className="kpi-grid">

        {Array.from({ length: kpiCount }).map((_, i) => (

          <StatCardSkeleton key={i} />

        ))}

      </div>

    </div>

  );

}


